import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen bg-[#060b14] text-white flex items-center px-6">
      <div className="max-w-xl mx-auto">
        <h1 className="font-display uppercase text-4xl md:text-6xl leading-[0.9] tracking-tight">
          Payment <span className="text-[#2a5fdb]">cancelled.</span>
        </h1>
        <p className="mt-4 text-white/60 leading-relaxed">
          No worries — your booking is still confirmed. You can pay by card
          later or sort it with cash or bank transfer at the session.
        </p>
        <Link to="/" data-testid="cancel-home-link" className="btn-sharp mt-10 inline-flex">
          Back to site <span aria-hidden>→</span>
        </Link>
      </div>
    </main>
  );
}
